export type Wrapper = 'Note' | 'Option' | 'Swap' | 'Warrant' | 'Deposit';

export type OtcWrapper = Extract<Wrapper, 'Option' | 'Swap'>;

export function isOtcWrapper(wrapper?: Wrapper): wrapper is OtcWrapper {
  return wrapper === 'Option' || wrapper === 'Swap';
}
